var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BrTimeStatusFilter',{on:{"change":_vm.handleChange}}),_c('BrTimeDistribution',{ref:"baseCountCardProductRef",staticStyle:{"margin-top":"18px"},attrs:{"data":_vm.tableData,"filter-form":_vm.filterForm}}),_c('BrTimeDistributionTable',{staticStyle:{"margin-top":"18px"},attrs:{"data":_vm.tableData,"filter-form":_vm.filterForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }